import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const TelegramTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={1} />
		</Box>
	);
};

export default TelegramTable;
